import t from "lib/i18n";
import "styles/components/favourites/loading.scss";

const FavouritesLoading = () => (
  <div className="otrl-jp__favourites-loading">
    <div className="otrl-jp__favourites-loading__message">{t("favourites.loading.message")}</div>
  </div>
);

export default FavouritesLoading;